import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import { TwitterButton } from 'react-social'
import {
  LinkIcon
} from '../'
import Styles from './PetitionRotatingTweet.css'

@CSSModules(Styles,{allowMultiple:true})
export default class PetitionRotatingTweet extends Component {
  static propTypes = {
    companyName: PropTypes.string.isRequired,
    tweets: PropTypes.array.isRequired,
    url: PropTypes.string.isRequired,
  }
  constructor(props){
    super(props)
    this.state = {
      companyName: props.companyName,
      tweets: props.tweets,
      url: props.url,
    }
  }
  render() {
    const { companyName, tweets, url } = this.state

    const randomTweet = tweets[Math.floor(Math.random() * tweets.length)]

    return (
      <div styleName='take-action-share'>
        <div styleName='take-action-label'>
          <h2>
            Send a Tweet to {companyName}
          </h2>
          <p>
            Send a Tweet to {companyName} letting them know how you feel.
          </p>
          <blockquote styleName='take-action-blockquote'>
            {randomTweet.jsx}
          </blockquote>
        </div>
        <div styleName='take-action-icons'>
          <div>
            <TwitterButton
              title='Send Tweet'
              message={randomTweet.plainText}
              url={url}
              element='a'
            >
              <p>
                Send Tweet
              </p>
              <div>
                <LinkIcon nospace faclass='fa-twitter-square'/>
              </div>
            </TwitterButton>
          </div>
        </div>
      </div>
    )
  }
}